export default __webpack_public_path__ + "static/media/lp.b2542792.jpg";